
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _2fa_45check0cP0cj6LZ9Meta } from "/opt/atlassian/pipelines/agent/build/pages/account/2fa-check.vue?macro=true";
import { default as _2faoe0h6ep4CqMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/2fa.vue?macro=true";
import { default as ordersLOpPSw5ytOMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/orders.vue?macro=true";
import { default as preferencesPSVW5E7PNJMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/preferences.vue?macro=true";
import { default as profileCyQDkm5msUMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/profile.vue?macro=true";
import { default as securityofxutOPGdHMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/security.vue?macro=true";
import { default as _91diaryId_93f5m3orZ31rMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/diaries/[diaryId].vue?macro=true";
import { default as createhivn7CV06CMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/diaries/create.vue?macro=true";
import { default as indexhmi5wFqUZuMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/diaries/index.vue?macro=true";
import { default as indexacA1FKmYeoMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/index.vue?macro=true";
import { default as _91noteId_930uvv575RGsMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/notes/[noteId].vue?macro=true";
import { default as createH5LZssLxUEMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/notes/create.vue?macro=true";
import { default as indexH34RdWwNXQMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/notes/index.vue?macro=true";
import { default as index6NU639P8zEMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/vehicles/index.vue?macro=true";
import { default as authenticateNBSNBOJ2xeMeta } from "/opt/atlassian/pipelines/agent/build/pages/authenticate.vue?macro=true";
import { default as contact_45usfh16CA1puhMeta } from "/opt/atlassian/pipelines/agent/build/pages/contact-us.vue?macro=true";
import { default as directbookingIrUwd8QUC8Meta } from "/opt/atlassian/pipelines/agent/build/pages/directbooking.vue?macro=true";
import { default as faqKMUjjrc0h9Meta } from "/opt/atlassian/pipelines/agent/build/pages/faq.vue?macro=true";
import { default as housep6bLGXudmKMeta } from "/opt/atlassian/pipelines/agent/build/pages/house.vue?macro=true";
import { default as indexOD9t3F2bSJMeta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as _91_91slug_93_935rmjEF4MLgMeta } from "/opt/atlassian/pipelines/agent/build/pages/info/[[slug]].vue?macro=true";
import { default as instantRoXujfpQRmh8Meta } from "/opt/atlassian/pipelines/agent/build/pages/instantRo.vue?macro=true";
import { default as insurancesmBgYagvdfMeta } from "/opt/atlassian/pipelines/agent/build/pages/insurance.vue?macro=true";
import { default as lihulQAwID69xMeta } from "/opt/atlassian/pipelines/agent/build/pages/lih.vue?macro=true";
import { default as maintenance5s9pKqcvvoMeta } from "/opt/atlassian/pipelines/agent/build/pages/maintenance.vue?macro=true";
import { default as _91inviteCode_93Eq0dRFNKOAMeta } from "/opt/atlassian/pipelines/agent/build/pages/partners/invite/[inviteCode].vue?macro=true";
import { default as _91_91vin_93_93r0nmNBVHcWMeta } from "/opt/atlassian/pipelines/agent/build/pages/rca-[partnerCode]/[[registration_plate]]/[[vin]].vue?macro=true";
import { default as _91_91vin_93_93edrFOBR2MRMeta } from "/opt/atlassian/pipelines/agent/build/pages/rca/[[registration_plate]]/[[vin]].vue?macro=true";
import { default as terms_45_91partnerCode_93FRYFum0jLWMeta } from "/opt/atlassian/pipelines/agent/build/pages/terms-[partnerCode].vue?macro=true";
import { default as thank_45youpnPduE5Zl7Meta } from "/opt/atlassian/pipelines/agent/build/pages/thank-you.vue?macro=true";
import { default as travelXoTodzSx64Meta } from "/opt/atlassian/pipelines/agent/build/pages/travel.vue?macro=true";
import { default as virtualcardstQWCM8BMZ4Meta } from "/opt/atlassian/pipelines/agent/build/pages/virtualcards.vue?macro=true";
import { default as payment_45processorZ0QAnQtfX1Meta } from "/opt/atlassian/pipelines/agent/build/pages/wait-to-be-redirected/payment-processor.vue?macro=true";
export default [
  {
    name: "account-2fa-check",
    path: "/account/2fa-check",
    meta: _2fa_45check0cP0cj6LZ9Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/2fa-check.vue")
  },
  {
    name: "account-2fa",
    path: "/account/2fa",
    meta: _2faoe0h6ep4CqMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/2fa.vue")
  },
  {
    name: "account-orders",
    path: "/account/orders",
    meta: ordersLOpPSw5ytOMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders.vue")
  },
  {
    name: "account-preferences",
    path: "/account/preferences",
    meta: preferencesPSVW5E7PNJMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/preferences.vue")
  },
  {
    name: "account-profile",
    path: "/account/profile",
    meta: profileCyQDkm5msUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/profile.vue")
  },
  {
    name: "account-security",
    path: "/account/security",
    meta: securityofxutOPGdHMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/security.vue")
  },
  {
    name: "account-vehicles-id-diaries-diaryId",
    path: "/account/vehicles/:id()/diaries/:diaryId()",
    meta: _91diaryId_93f5m3orZ31rMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/diaries/[diaryId].vue")
  },
  {
    name: "account-vehicles-id-diaries-create",
    path: "/account/vehicles/:id()/diaries/create",
    meta: createhivn7CV06CMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/diaries/create.vue")
  },
  {
    name: "account-vehicles-id-diaries",
    path: "/account/vehicles/:id()/diaries",
    meta: indexhmi5wFqUZuMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/diaries/index.vue")
  },
  {
    name: "account-vehicles-id",
    path: "/account/vehicles/:id()",
    meta: indexacA1FKmYeoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/index.vue")
  },
  {
    name: "account-vehicles-id-notes-noteId",
    path: "/account/vehicles/:id()/notes/:noteId()",
    meta: _91noteId_930uvv575RGsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/notes/[noteId].vue")
  },
  {
    name: "account-vehicles-id-notes-create",
    path: "/account/vehicles/:id()/notes/create",
    meta: createH5LZssLxUEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/notes/create.vue")
  },
  {
    name: "account-vehicles-id-notes",
    path: "/account/vehicles/:id()/notes",
    meta: indexH34RdWwNXQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/vehicles/[id]/notes/index.vue")
  },
  {
    name: "account-vehicles",
    path: "/account/vehicles",
    meta: index6NU639P8zEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/vehicles/index.vue")
  },
  {
    name: "authenticate",
    path: "/authenticate",
    meta: authenticateNBSNBOJ2xeMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/authenticate.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/contact-us.vue")
  },
  {
    name: "directbooking",
    path: "/directbooking",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/directbooking.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/faq.vue")
  },
  {
    name: "house",
    path: "/house",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/house.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "info-slug",
    path: "/info/:slug?",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/info/[[slug]].vue")
  },
  {
    name: "instantRo",
    path: "/instantRo",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/instantRo.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/insurance.vue")
  },
  {
    name: "lih",
    path: "/lih",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/lih.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/maintenance.vue")
  },
  {
    name: "partners-invite-inviteCode",
    path: "/partners/invite/:inviteCode()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/partners/invite/[inviteCode].vue")
  },
  {
    name: "rca-partnerCode-registration_plate-vin",
    path: "/rca-:partnerCode()/:registration_plate?/:vin?",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/rca-[partnerCode]/[[registration_plate]]/[[vin]].vue")
  },
  {
    name: "rca-registration_plate-vin",
    path: "/rca/:registration_plate?/:vin?",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/rca/[[registration_plate]]/[[vin]].vue")
  },
  {
    name: "terms-partnerCode",
    path: "/terms-:partnerCode()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/terms-[partnerCode].vue")
  },
  {
    name: "thank-you",
    path: "/thank-you",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/thank-you.vue")
  },
  {
    name: "travel",
    path: "/travel",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/travel.vue")
  },
  {
    name: "virtualcards",
    path: "/virtualcards",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/virtualcards.vue")
  },
  {
    name: "wait-to-be-redirected-payment-processor",
    path: "/wait-to-be-redirected/payment-processor",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/wait-to-be-redirected/payment-processor.vue")
  }
]